import { ModelBase } from '../../core/model/model-base';

export class Payer extends ModelBase {
  constructor() {
    super();
  }

  get displayName(): string {
    return this.name;
  }
  name: string;

  toJSON() {
    return this.id;
  }

  toString() {
    return this.name;
  }
}
